import { Placeholder, Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { C01AccordionProps } from './C01Accordion.types';
import { ACCORDION_ITEM_CONTAINER } from 'src/shared/static';
import { SvgIconType } from '@ahc-digital/component-library';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';

export function CreateAccordionWrapperModel(props?: C01AccordionProps) {
  const { renderRichText } = useConditionalRendering();
  const titleAlignment: 'center' | 'left' | undefined =
    props?.params?.TitleAlignment === 'center' || props?.params?.TitleAlignment === 'left'
      ? props.params.TitleAlignment
      : 'left';
  const titleTypeValue = props?.fields?.TitleType?.fields?.Value?.value;
  const tag: 'h2' | 'h3' | 'p' =
    titleTypeValue === 'h2' || titleTypeValue === 'h3' || titleTypeValue === 'p'
      ? titleTypeValue
      : 'p';

  const iconPlacement: 'left' | 'top' =
    props?.params?.IconPlacement === 'left' || props?.params?.IconPlacement === 'top'
      ? props.params.IconPlacement
      : 'left';

  const type: 'single' | 'multiple' | undefined = props?.params?.LimitToSingleItem
    ? 'single'
    : 'multiple';

  const shouldOpenFirstItem = !!props?.params?.OpenFirstItem;

  const defaultOpenItem =
    props?.rendering?.placeholders?.[ACCORDION_ITEM_CONTAINER]?.find(({ uid }) => !!uid)?.uid || '';

  return {
    title: {
      alignment: titleAlignment,
      tag: tag,
      value: <Text field={props?.fields?.Title} />,
    },
    bottomDescription: renderRichText(props?.fields?.BottomSupportingCopy),
    icon: props?.fields?.TitleIcon?.fields?.Value?.value
      ? {
          placement: iconPlacement,
          value: props?.fields?.TitleIcon?.fields?.Value?.value as SvgIconType,
        }
      : undefined,
    shouldOpenFirstItem: shouldOpenFirstItem,
    topDescription: renderRichText(props?.fields?.TopSupportingCopy),
    type: type,
    defaultOpenItem: defaultOpenItem,
    accordionItems: props?.rendering ? (
      <Placeholder name={ACCORDION_ITEM_CONTAINER} rendering={props.rendering} />
    ) : (
      <></>
    ),
  };
}
